import Vue from 'vue';
import newYearScrollVue from './newYearScroll.vue';
import store from '@/store/index';
let NewYearScrollConstructor = Vue.extend(newYearScrollVue);
const NewYearScroll = (userKey, gameID) => {
	const data = Array.from(store.state.newYearScroll.data);
	let style = 1;
	const style2GameIDs = [ 1001, 1018 ];
	const style3GameIDs = [ 1019, 1022 ];
	if (style2GameIDs.includes(gameID)) {
		style = 2;
	} else if (style3GameIDs.includes(gameID)) {
		style = 3;
	}
	const saveKey = `${userKey}-${gameID}`;
	if (data.length == 0 || !data.includes(saveKey)) {
		data.push(saveKey);
		store.dispatch('setNewYearScroll', data);
		let instance = new NewYearScrollConstructor({
			data: {
				style: style
			}
		});
		instance._vm = instance.$mount();
		instance._el = instance.$el;
		instance._instance = instance;
		document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
		return instance;
	}
};
export default NewYearScroll;
